import { Refresh } from '@mui/icons-material';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import { useDisclose } from 'basic-react-hooks';
import Empty from 'components/Empty';
import InvoicesTable from 'components/Table/InvoicesTable';
import { EVENT_NAME } from 'constant/eventName';
import useAddEvent from 'hooks/useAddEvent';
import useFetchPublicUserInfo from 'hooks/useFetchPublicUserInfo';
import React, { useEffect, useState } from 'react';
import { getPublicUserInvoices } from 'rest_client/publicUserClient';

const ListInvoices = ({ onViewInvoice }) => {
  const {
    isOpen: isLoading,
    onOpen: onStartLoading,
    onClose: onStopLoading,
  } = useDisclose();
  const {
    isOpen: isFetchingData,
    onOpen: onStartFetchData,
    onClose: onStopFetchData,
  } = useDisclose();
  const [list, setList] = useState([]);
  const { getUserInfo } = useFetchPublicUserInfo(false);

  const onFetchListInvoices = async (initLoading = true) => {
    if (initLoading) {
      onStartLoading();
    }
    try {
      const { data } = await getPublicUserInvoices();
      setList(data.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      onStopLoading();
    }
  };

  const onRefresh = async () => {
    onStartFetchData();
    await onFetchListInvoices(false);
    await getUserInfo();
    onStopFetchData();
  };

  useEffect(() => {
    onFetchListInvoices();
  }, []);
  useAddEvent(EVENT_NAME.fetchInvoices, () => {
    onFetchListInvoices(false);
  });

  if (isLoading) {
    return (
      <Box display={'flex'} justifyContent={'center'} mt={5}>
        <CircularProgress size={45} />
      </Box>
    );
  }

  return (
    <Box>
      <Box display={'flex'} alignItems={'center'} gap={'5px'} mt={2}>
        <Typography fontWeight={700} fontSize={16}>
          Invoices
        </Typography>
        <IconButton
          onClick={onRefresh}
          disabled={isFetchingData}
          sx={{
            p: '4px',
          }}
        >
          {isFetchingData ? <CircularProgress size={24} /> : <Refresh />}
        </IconButton>
      </Box>
      {list.length > 0 ? (
        <InvoicesTable data={list} onClickViewInvoice={onViewInvoice} />
      ) : (
        <Empty title="No invoice yet" sx={{ mb: 4 }} />
      )}
    </Box>
  );
};

export default ListInvoices;
